export default function getOrderStatus(status, messages, orderType) {
    switch (status) {
        case 'Created':
            if (orderType?.toLowerCase() === 'exchange') {
                return { statusEN: status, status: messages.orderStatus.exchangeOrdered() }
            }
            return { statusEN: status, status: messages.orderStatus.ordered() }
        case 'Procurement Transfer Order Created':
        case 'Awaiting Procurement Transfer Order Creation':
        case 'Partially Procurement Transfer Order Created':
        case 'Partially Awaiting Procurement Transfer Order Creation':
        case 'Scheduled':
        case 'Backordered':
        case 'Partially Scheduled':
        case 'Unscheduled':
        case 'Order Being Packed':
        case 'Released':
        case 'Partially Released':
        case 'Partially Included In Shipment':
        case 'Included In Shipment':
        case 'Partially Order Being Packed':
            if (orderType?.toLowerCase() === 'exchange') {
                return { statusEN: status, status: messages.orderStatus.exchangeProcessing() }
            }
            return { statusEN: status, status: messages.orderStatus.processing() }
        case 'Shipped':
        case 'Partially Shipped':
        case 'Partially Shipped and Invoiced':
        case 'Shipped and Invoiced':
        case 'Partially Return Reshipped':
            return { statusEN: status, status: messages.orderStatus.dispatched() }
        case 'Cancelled':
            return { statusEN: status, status: messages.orderStatus.cancelled() }
        case 'Return Form Created':
        case 'Partially Return Form Created':
            return { statusEN: status, status: messages.orderStatus.returnRequested() }
        case 'Return Accepted':
        case 'Return Cancelled':
        case 'Partially Return Accepted':
            return { statusEN: status, status: messages.orderStatus.returnReceived() }
        case 'Return Refunded':
        case 'Return Reshipped':
            return { statusEN: status, status: messages.orderStatus.returned() }
        case 'Partially Return Refunded':
            return { statusEN: status, status: messages.orderStatus.returnCompleted() }
        case 'Exchanged':
        case 'Partially Exchanged':
            return { statusEN: status, status: messages.orderStatus.exchanged() }
        case 'Partially Accepted for Exchange':
        case 'Accepted for Exchange':
            return { statusEN: status, status: messages.orderStatus.exchangeReceived() }
        case 'Return Refused':
        case 'Partially Return Refused':
            return { statusEN: status, status: messages.orderStatus.returnRefused() }
        default:
            return { statusEN: status, status: '' }
    }
}
